import store from '@/store';
import BADGES_COLOR_MAP from '@/data/badges-color-map';
import auth from '@/common/auth/auth';
import _ from '@/common/helpers';
import checkbox from '@/components/grid/columns/predefined/checkbox';
import batchRefund from '@/common/definitions/batch-actions/refund';

export default {
    store,
    version: 6,
    customFields: 'transactions',
    batchActions: [
        batchRefund,
    ],
    actionColumns: [
        checkbox,
    ],
    defaultColumns: [
        {
            name: 'id',
            type: 'link',
            to: ({fields}) => ({
                name: 'transaction-details',
                params: {
                    id: fields.id,
                },
            }),
            predicate: auth.$pages['transaction-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            style: {truncate: true},
            sortable: true,
            sticky: true,
        },
        {
            header: 'Customer',
            name: 'customerId',
            type: 'link',
            expand: 'customer',
            value: fields => _.getIdentifier({concat: ['firstName', 'lastName']})(fields._embedded.customer),
            to: ({fields}) => ({
                name: 'customer-details',
                params: {
                    id: fields.customerId,
                },
            }),
            predicate: auth.$pages['customer-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
        },
        {
            name: 'type',
            type: 'badge',
            map: BADGES_COLOR_MAP.type,
            sortable: true,
        },
        {
            name: 'result',
            type: 'badge',
            map: BADGES_COLOR_MAP.result,
            sortable: true,
        },
        {
            header: 'Gateway Account',
            name: 'gatewayName',
        },
        {
            header: 'Processed On',
            name: 'processedTime',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'amount',
            type: 'numeric',
            approx: false,
            currency: 'currency',
            format: 'currency',
            sortable: true,
        },
    ],
    otherColumns: [
        {
            name: 'organizationId',
        },
        {
            name: 'currency',
        },
        {
            name: 'requestId',
            sortable: true,
        },
        {
            name: 'orderId',
            sortable: true,
        },
        {
            name: 'status',
            type: 'badge',
            map: BADGES_COLOR_MAP.status,
        },
        {
            name: 'childTransactions',
            type: 'link',
            to: ({value}) => ({
                name: 'transaction-details',
                params: {
                    id: value,
                },
            }),
            predicate: auth.$pages['transaction-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
        },
        {
            name: 'acquirerName',
        },
        {
            name: 'billingContactId',
        },
        {
            name: 'billingAddress.firstName',
        },
        {
            name: 'billingAddress.lastName',
        },
        {
            name: 'billingAddress.organization',
        },
        {
            name: 'billingAddress.address',
        },
        {
            name: 'billingAddress.address2',
        },
        {
            name: 'billingAddress.city',
        },
        {
            name: 'billingAddress.region',
        },
        {
            name: 'billingAddress.postalCode',
        },
        {
            name: 'billingAddress.country',
        },
        {
            name: 'billingAddress.phoneNumbers',
            type: 'complex',
            map: v => v.value,
        },
        {
            name: 'billingAddress.emails',
            type: 'complex',
            map: v => v.value,
        },
        {
            header: 'BIN',
            name: 'bin',
        },
        {
            header: 'Created On',
            name: 'createdTime',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'currency',
        },
        {
            name: 'dcc.base.amount',
            type: 'numeric',
        },
        {
            name: 'dcc.base.currency',
        },
        {
            name: 'dcc.quote.amount',
            type: 'numeric',
        },
        {
            name: 'dcc.quote.currency',
        },
        {
            name: 'dcc.usdMarkup',
        },
        {
            name: 'dcc.outcome',
        },
        {
            name: 'description',
        },
        {
            name: 'gatewayAccountId',
            type: 'link',
            to: ({fields}) => ({
                name: 'gateway-account-details',
                params: {
                    id: fields.gatewayAccountId,
                },
            }),
            predicate: auth.$pages['gateway-account-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            style: {truncate: true},
            sortable: true,
        },
        {
            name: 'gatewayName',
        },
        {
            name: 'gateway.response.message',
        },
        {
            name: 'gateway.response.code',
        },
        {
            name: 'gateway.response.originalCode',
        },
        {
            name: 'gateway.response.originalMessage',
        },
        {
            name: 'gateway.avsResponse.message',
        },
        {
            name: 'gateway.avsResponse.code',
        },
        {
            name: 'gateway.avsResponse.originalCode',
        },
        {
            name: 'gateway.avsResponse.originalMessage',
        },
        {
            name: 'gateway.cvvResponse.message',
        },
        {
            name: 'gateway.cvvResponse.code',
        },
        {
            name: 'gateway.cvvResponse.originalCode',
        },
        {
            name: 'gateway.cvvResponse.originalMessage',
        },

        {
            name: 'gatewayTransactionId',
        },
        {
            name: 'hadDiscrepancy',
        },
        {
            name: 'has3ds',
        },
        {
            name: 'hasDcc',
        },
        {
            name: 'invoiceIds',
        },
        {
            name: 'isDisputed',
        },
        {
            name: 'isRebill',
        },
        {
            name: 'isReconciled',
        },
        {
            name: 'isRetry',
        },
        {
            name: 'method',
        },
        {
            name: 'parentTransactionId',
            type: 'link',
            to: ({fields}) => ({
                name: 'transaction-details',
                params: {
                    id: fields.parentTransactionId,
                },
            }),
            predicate: auth.$pages['transaction-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            style: {truncate: true},
            sortable: true,
        },
        {
            name: 'paymentCardId',
        },
        // {
        //     name: 'paymentInstrument',
        // },
        {
            name: 'planIds',
        },
        {
            name: 'processedTime',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'processorAccount',
        },
        // {
        //     name: 'processorResponse',
        // },
        {
            name: 'rebillNumber',
            type: 'numeric',
        },
        {
            name: 'redirectUrls',
        },
        {
            name: 'retriedTransactionId',
            type: 'link',
            to: ({fields}) => ({
                name: 'transaction-details',
                params: {
                    id: fields.retriedTransactionId,
                },
            }),
            predicate: auth.$pages['transaction-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            style: {truncate: true},
            sortable: true,
        },
        {
            name: 'retriesResult',
        },
        {
            name: 'retryNumber',
            type: 'numeric',
        },
        // {
        //     name: 'riskMetadata',
        // },
        {
            name: 'riskScore',
            type: 'numeric',
        },
        {
            name: 'scheduledTime',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'subscriptionIds',
        },
        {
            name: 'updatedTime',
            header: 'Last Update Time',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'velocity',
            type: 'numeric',
        },
        {
            name: 'websiteId',
        },
        // lead source
        {
            name: 'leadSource.campaign',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.medium',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.source',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.term',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.content',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.affiliate',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.subAffiliate',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.salesAgent',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.amount',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.path',
            expand: 'leadSource',
        },
        // customer
        {
            name: 'customer.id',
            expand: 'customer',
        },
        {
            name: 'customer.email',
            expand: 'customer',
        },
        {
            name: 'customer.createdTime',
            expand: 'customer',
        },
        {
            name: 'customer.updatedTime',
            expand: 'customer',
        },
        {
            header: 'Customer Lifetime Revenue',
            type: 'numeric',
            format: 'currency',
            approx: false,
            currency: 'customer.lifetimeRevenue.currency',
            name: 'customer.lifetimeRevenue.amount',
            expand: 'customer',
        },
        {
            header: 'Customer Average Value',
            type: 'numeric',
            format: 'currency',
            approx: false,
            currency: 'customer.averageValue.currency',
            name: 'customer.averageValue.amount',
            expand: 'customer',
        },
        {
            header: 'Customer Payments',
            name: 'customer.paymentCount',
            type: 'numeric',
            expand: 'customer',
        },
        {
            header: 'Customer Last Payment',
            name: 'customer.lastPaymentTime',
            type: 'datetime',
            expand: 'customer',
        },
        // payment card
        {
            name: 'paymentCard.id',
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.last4',
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.bin',
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.expYear',
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.expMonth',
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.status',
            type: 'badge',
            map: BADGES_COLOR_MAP.cardStatus,
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.brand',
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.bankName',
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.bankCountry',
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.panFingerprint',
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.createdTime',
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.updatedTime',
            expand: 'paymentCard',
        },
        {
            name: 'paymentCard.stickyGatewayAccountId',
            expand: 'paymentCard',
        },
        {
            name: 'hasBumpOffer',
        },
        {
            name: 'bumpOffer.outcome',
        },
        {
            header: 'Bump Offer Order Amount',
            type: 'numeric',
            format: 'currency',
            approx: false,
            currency: 'bumpOffer.order.currency',
            name: 'bumpOffer.order.amount',
        },
        {
            header: 'Bump Offer Bump Amount',
            type: 'numeric',
            format: 'currency',
            approx: false,
            currency: 'bumpOffer.bump.currency',
            name: 'bumpOffer.bump.amount',
        },
        {
            header: 'Bump Offer Bonus Amount',
            type: 'numeric',
            format: 'currency',
            approx: false,
            currency: 'bumpOffer.bonus.currency',
            name: 'bumpOffer.bonus.amount',
        },
        {
            header: 'Bump Offer Order Amount in USD',
            type: 'numeric',
            name: 'bumpOffer.usdOrder',
        },
        {
            header: 'Bump Offer Bump Amount in USD',
            type: 'numeric',
            name: 'bumpOffer.usdBump',
        },
        {
            header: 'Bump Offer Bonus Amount in USD',
            type: 'numeric',
            name: 'bumpOffer.usdBonus',
        },
        {
            name: 'revision',
            type: 'numeric',
        },
        {
            name: 'purchaseAmount',
            type: 'numeric',
            approx: false,
            currency: 'purchaseCurrency',
            format: 'currency',
            sortable: false,
        },
        {
            name: 'requestAmount',
            type: 'numeric',
            approx: false,
            currency: 'requestCurrency',
            format: 'currency',
            sortable: false,
        },
        {
            name: 'isProcessedOutside',
        },
    ],

};
